import React from 'react';
import { useQuery } from "react-query";

import { fetchClientInfosGenerales } from 'utils/queries';

import InfosGenerales from './InfosGenerales';
import withLoader from 'components/Shared/withLoader';

const InfosGeneralesWithLoader = withLoader(InfosGenerales);

const InfosGeneralesContainer = ({ idClient, numeroPiece }) => {

    // Hook des infos générales
    const [infosGenerales, setInfoGenerales] = React.useState(null);

    // Hook du loader
    const [loading, setLoading] = React.useState(true);

    /** On récupère les infos générales d'un client */
    const query = useQuery(`ClientInfosGenerales_${idClient}`, () => fetchClientInfosGenerales(idClient, numeroPiece), {
        staleTime: Infinity
    });

    React.useEffect(() => {

        if (!query.isLoading && !query.error && query.data) {
            setLoading(query.isLoading);
            setInfoGenerales(query.data);
        }

    }, [infosGenerales, query]);

    return (
        <>
            <InfosGeneralesWithLoader
                isLoading={loading}
                infosGenerales={infosGenerales}
            />
        </>
    )
}

export default InfosGeneralesContainer;